/**
* 支付管理 支付配置
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工资</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <template>
          <div class="block">
            <el-date-picker
              size="small"
              type="month"
              value-format="yyyy-MM"
              v-model="formInline.generateDate"
              :picker-options="pickerOptions"
              placeholder="请求选择搜索的月份">
            </el-date-picker>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.staffName" placeholder="输入员工姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="payroll()">工资发放</el-button>
        <ShopReportDownload />
      </el-form-item>
    </el-form>

    <!-- 编辑界面 -->
    <el-dialog title="修改工资信息" :visible.sync="editWageFormVisible" width="60%" @click="closeDialog">
      <el-form label-width="160px" :model="editWageForm" :rules="rules" ref="editForm">
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="姓名" prop="staffName">
              <el-input size="small" v-model="editWageForm.staffDto.staffName" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="月份" prop="wagesCycle">
              <el-input size="small" v-model="editWageForm.wagesCycle" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="考勤天数" prop="attendanceNum">
              <el-input size="small" v-model="editWageForm.attendanceNum" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="基础薪资" prop="basicSalary">
              <el-input size="small"v-model="editWageForm.basicSalary" auto-complete="off" @input="changeWage()" placeholder="请输入基础薪资" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="会员手工提成" prop="memberHandmadeCommission">
              <el-input size="small" v-model="editWageForm.memberHandmadeCommission" auto-complete="off" @input="changeWage()" placeholder="请输入会员手工提成"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="普通手工提成" prop="ordinaryHandmadeCommission">
              <el-input size="small" v-model="editWageForm.ordinaryHandmadeCommission" auto-complete="off" @input="changeWage()" placeholder="请输入普通手工提成"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editWageForm.eyelashCommission !== null" type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="美睫提成" prop="eyelashCommission">
              <el-input size="small" v-model="editWageForm.eyelashCommission" auto-complete="off" @input="changeWage()" placeholder="请输入美睫提成"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="办卡提成" prop="newCardCommission">
              <el-input size="small" v-model="editWageForm.newCardCommission" auto-complete="off" @input="changeWage()" placeholder="请输入办卡提成"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="充值提成" prop="rechargeCommission">
              <el-input size="small" v-model="editWageForm.rechargeCommission" auto-complete="off" @input="changeWage()" placeholder="请输入充值提成"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="绩效奖励" prop="performanceCommission">
              <el-input size="small" v-model="editWageForm.performanceCommission" auto-complete="off" @input="changeWage()" placeholder="请输入绩效奖励"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="其他奖励" prop="otherReward">
              <el-input size="small" v-model="editWageForm.otherReward" auto-complete="off" @input="changeWage()" placeholder="加班/外项/手工调整"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="10">
            <el-form-item label="总工资" prop="totalWage">
              <el-input size="small" v-model="editWageForm.totalWage" auto-complete="off" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeWageDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="staffDto.staffName" label="员工名" align="center" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="wagesCycle" label="月份" align="center" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="attendanceNum" label="考勤" align="center" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="basicSalary" label="基础薪资" align="center" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="memberHandmadeCommission" label="会员手工提成" align="center" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="ordinaryHandmadeCommission" label="普通手工提成" align="center" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="eyelashCommission" label="美睫提成" align="center" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.eyelashCommission == null ? '—' : scope.row.eyelashCommission}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="newCardCommission" label="办卡提成" width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="rechargeCommission" label="充值提成" width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="performanceCommission" label="绩效奖励" width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="otherReward" label="其他奖励" width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="totalWage" label="总工资" width="90" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="确认状态" width="105" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.archivedAt" type="success">已归档</el-tag>
          <el-tag v-else-if="scope.row.confirmationStatus===1" type="warning">已确认</el-tag>
          <el-tag v-else type="info">待确认</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="170">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" v-if="!scope.row.archivedAt">编辑</el-button>
          <el-button size="mini" type="success" @click="confirmSalary(scope.row)"
                     v-if="!scope.row.archivedAt && scope.row.confirmationStatus!==1">店长确认</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 获取未发工资日期列表页 -->
    <el-dialog :title="title" :visible.sync="payrollFormVisible"  width="20%" @click="closeDialog('payrollForm')">
      <template>
        <div class="block">
          <el-date-picker
            size="small"
            type="month"
            value-format="yyyy-MM"
            v-model="payrollForm.generateDate"
            :picker-options="pickerOptions"
            placeholder="请求选择要生成工资的月份">
          </el-date-picker>
        </div>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="generateSalary()">生成</el-button>
      </div>
    </el-dialog>
    <!-- 获取未发工资数据列表页 -->
    <el-dialog :title="pendSalaryTitle" :visible.sync="pendSalaryVisible"  width="87%" @click="closePendSalaryDialog()">
      <template>
        <el-table size="small" :data="pendSalaryData" highlight-current-row v-loading="pendSalaryLoading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column sortable prop="staffDto.staffName" label="员工名" align="center" width="90" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="totalWorkDayNum" label="总工作日" align="center" width="143" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.totalWorkDayNum" size="mini" controls-position="right" :step="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column sortable prop="attendanceNum" label="考勤天数" align="center" width="143" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.attendanceNum" size="mini"  controls-position="right":step="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column sortable prop="basicSalary" label="基础薪资" align="center" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center" >({{ scope.row.staffDto.basicSalary }}/{{scope.row.totalWorkDayNum}})*{{scope.row.attendanceNum}}</p>
                <p>(底薪/总工作日)*考勤天数</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{calculateBasicSalary(scope.row)}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="memberHandmadeCommission" label="会员手工提成" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center">({{scope.row.memberHandicraft}})*{{scope.row.performanceTemplateDto.memberHandmade}}</p>
                <p>会员手工/会员手工提成</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.memberHandmadeCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="ordinaryHandmadeCommission" label="普通手工提成" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center"> ({{scope.row.unMemberHandicraft}})*{{scope.row.performanceTemplateDto.ordinaryHandmade}}</p>
                <p>非会员手工/非会员手工提成</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.ordinaryHandmadeCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="eyelashCommission" label="美睫提成" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover v-if="scope.row.eyelashCommission != null" trigger="hover" placement="top">
                <p align="center">({{scope.row.eyelashHandicraft}})*{{scope.row.staffDto && scope.row.staffDto.eyelashCommission != null ? scope.row.staffDto.eyelashCommission : 0.23}}</p>
                <p>美睫手工（会员+非会员）/美睫提成比例</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.eyelashCommission}}</el-tag>
                </div>
              </el-popover>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="newCardCommission" label="办卡提成" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center">({{scope.row.newCardTotal}})*{{scope.row.performanceTemplateDto.newCard}}</p>
                <p>办卡总额/办卡提成</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.newCardCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="rechargeCommission" label="充值提成" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center">({{scope.row.rechargeTotal}})*{{scope.row.performanceTemplateDto.renewCard}}</p>
                <p>办卡总额/办卡提成</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.rechargeCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="performanceCommission" label="绩效奖励" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <table border="1" class=table11_7>
                  <tr>
                    <th>奖励名称</th>
                    <th>奖励周期</th>
                    <th>达标值</th>
                    <th>{奖励金额</th>
                  </tr>
                  <tr v-for="item in scope.row.staffRewardList" :key="item.rewardId">
                    <td>{{item.cycleName}}</td>
                    <td>{{item.rewardName}}</td>
                    <td>{{item.standardValue}}</td>
                    <td>{{item.amount}}</td>
                  </tr>
                </table>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.performanceCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="totalWage" label="总工资" width="132" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p align="center">{{ scope.row.basicSalary }}+{{scope.row.memberHandmadeCommission}}+{{scope.row.ordinaryHandmadeCommission}}<template v-if="scope.row.eyelashCommission != null">+{{scope.row.eyelashCommission}}</template>+{{scope.row.newCardCommission}}+{{scope.row.rechargeCommission}}+{{scope.row.performanceCommission}}</p>
                <p>(底薪+会员手工提成+普通手工提成<template v-if="scope.row.eyelashCommission != null">+美睫提成</template>+办卡提成+充值提成+绩效奖励)</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium">{{scope.row.basicSalary+scope.row.memberHandmadeCommission+scope.row.ordinaryHandmadeCommission+(scope.row.eyelashCommission||0)+scope.row.newCardCommission+scope.row.rechargeCommission+scope.row.performanceCommission}}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePendSalaryDialog()">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="savePendSalary()">保存</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {
  ConfigDelete,
  getUnpaidSalaryDateList,
  generateUnpaidSalaryWageList, savePendSalary, queryWagePage, updateWage, confirmWage
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
import ShopReportDownload from '../../components/ShopReportDownload'
import {saveOrUpdateStaff} from "../../api/userMG";
export default {
  data() {
    return {
      loading: false, //是显示加载
      pendSalaryLoading:false,// 待发薪资加载
      payrollFormVisible: false, //控制编辑页面显示与隐藏
      pendSalaryVisible:false, //待发薪资列表
      pendSalaryTitle:'',// 待发工资标题
      editWageFormVisible: false,
      editWageForm:{
        wageId:0,
        staffDto:{
          staffName:""
        },
        wagesCycle:"",
        attendanceNum:0,
        basicSalary:0,
        memberHandmadeCommission:0,
        ordinaryHandmadeCommission:0,
        eyelashCommission:null,
        newCardCommission:0,
        rechargeCommission:0,
        performanceCommission:0,
        otherReward:0,
        totalWage:0
      },
      title: '',
      pickerOptions: {},
      staffRewardList:[],
      pendSalaryData:[{
        wagesCycle:'',
        attendanceNum:null,
        totalHandicraft:null,
        unMemberHandicraft:null,
        memberHandicraft:null,
        newCardNum:null,
        newCardTotal:null,
        rechargeNum:null,
        rechargeTotal:null,
        favorableNum:null,
        basicSalary:null,
        totalWorkDayNum:null,
        everyDaySalary:null,
        memberHandmadeCommission:null,
        ordinaryHandmadeCommission:null,
        newCardCommission:null,
        rechargeCommission:null,
        performanceCommission:null,
        otherReward:0,
        totalWage:null,
        status:null,
        performanceTemplateDto:{
          ordinaryHandmade:null,
          memberHandmade:null,
          newCard:null,
          renewCard:null
        },
        staffDto:{
          staffName:'',
          staffWechatName:''
        }

      }],
      payType: [
        { key: '请选择', value: 0 },
        { key: '现金', value: 1 },
        { key: '支付宝', value: 2 },
        { key: '微信', value: 3 },
        { key: 'POS通', value: 4 },
        { key: '闪付', value: 5 },
        { key: 'POS通C扫B', value: 6 },
        { key: '银联二维码', value: 8 },
        { key: '会员余额支付', value: 9 }
      ],
      payrollForm: {
        generateDate: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        current: 1,
        size: 10,
        generateDate: '',
        staffName:'',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    ShopReportDownload,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading=true
      queryWagePage(parameter).then(res => {
        this.loading = false
        if (res.code !== '200') {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          // 分页赋值
          this.listData = res.data.content
          // 分页赋值
          this.pageparm.currentPage = res.data.pages
          this.pageparm.total = res.data.total
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('查询薪资列表异常，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示未发工资日历数据
    payroll: function(index, row) {
      getUnpaidSalaryDateList(this.payrollForm).then(res => {
        if (res.code==='200') {
          this.pickerOptions= {
            disabledDate(time) {
              return time.getTime()<new Date(res.data)||time.getTime()>Date.now();
            }
          };
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
        }
      }).catch(() => {
        this.payrollFormVisible = false
        this.$message.error('查询未开工资日期列表异常，请稍后再试！')
      })
      this.payrollFormVisible = true
    },
    // 编辑、增加页面保存方法
    generateSalary() {
      this.pendSalaryTitle=this.payrollForm.generateDate+'待发工资列表';
      this.pendSalaryVisible=true
      this.pendSalaryLoading=true
      generateUnpaidSalaryWageList(this.payrollForm).then(res => {
        if (res.code==='200') {
          this.pendSalaryLoading=false
          this.pendSalaryData=res.data
          console.info(res)
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
        }
      }).catch(err => {
        this.payrollFormVisible = false
        this.loading = false
        this.$message.error('获取未发工资列表失败！')
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ConfigDelete(row.deptId)
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '公司已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('支付配置信息删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    savePendSalary(){
      this.pendSalaryVisible=true
      savePendSalary(this.pendSalaryData).then(res => {
        if (res.code==='200') {
          this.pendSalaryVisible=false
          this.payrollFormVisible=false
          this.pendSalaryLoading=false
          this.getdata(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
        }
      }).catch(err => {
        this.payrollFormVisible = false
        this.loading = false
        this.$message.error('保存工资列表失败！')
      })

    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.payrollFormVisible = false
    },
    closePendSalaryDialog(){
      this.pendSalaryVisible=false;
    },
    calculateBasicSalary(wage){
      if(wage.totalWorkDayNum===wage.attendanceNum){
        return wage.staffDto.basicSalary
      }
      let newBasicSalary =parseFloat(((wage.staffDto.basicSalary/wage.totalWorkDayNum)* wage.attendanceNum).toFixed(0));
      wage.basicSalary=newBasicSalary
      return newBasicSalary;
    },
    handleEdit(row){
      this.editWageFormVisible=true
      this.editWageForm.wageId=row.wageId
      this.editWageForm.staffDto.staffName=row.staffDto.staffName
      this.editWageForm.wagesCycle=row.wagesCycle
      this.editWageForm.attendanceNum=row.attendanceNum
      this.editWageForm.basicSalary=row.basicSalary
      this.editWageForm.memberHandmadeCommission=row.memberHandmadeCommission
      this.editWageForm.ordinaryHandmadeCommission=row.ordinaryHandmadeCommission
      // 美睫提成 2026-10 起才有，之前的月份为空、不显示这一项
      this.editWageForm.eyelashCommission=row.eyelashCommission == null ? null : row.eyelashCommission
      this.editWageForm.newCardCommission=row.newCardCommission
      this.editWageForm.rechargeCommission=row.rechargeCommission
      this.editWageForm.performanceCommission=row.performanceCommission
      this.editWageForm.otherReward=row.otherReward || 0
      this.editWageForm.totalWage=row.totalWage
    },
    closeWageDialog(){
      this.editWageFormVisible=false
    },
    submitForm(){
      updateWage(this.editWageForm).then(res => {
        if (res.code==='200') {
          this.editWageFormVisible=false
          this.getdata(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })
        }
      }).catch(err => {
        this.payrollFormVisible = false
        this.loading = false
        this.$message.error('保存工资列表失败！')
      })

    },
    confirmSalary(row){
      this.$confirm('确认后，当月全部员工都确认时系统将自动归档。是否继续？', '工资确认', {
        confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning'
      }).then(() => confirmWage({wageId: row.wageId})).then(res => {
        if (res.code === '200') {
          this.$message.success('工资已确认')
          this.getdata(this.formInline)
        } else {
          this.$message.error(res.message || '确认失败')
        }
      }).catch(() => {})
    },
    changeWage(){
      this.editWageForm.totalWage=Number(this.editWageForm.basicSalary)
      +Number(this.editWageForm.memberHandmadeCommission)
      +Number(this.editWageForm.ordinaryHandmadeCommission)
      +Number(this.editWageForm.eyelashCommission || 0)
      +Number(this.editWageForm.newCardCommission)
      +Number( this.editWageForm.rechargeCommission)
      +Number(this.editWageForm.performanceCommission)
      +Number(this.editWageForm.otherReward || 0)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.table11_7 table {
  width:100%;
  margin:15px 0;
  border:0;
}
.table11_7 th {
  background-color:#00A5FF;
  color:#FFFFFF
}
.table11_7,.table11_7 th,.table11_7 td {
  font-size:0.95em;
  text-align:center;
  padding:4px;
  border-collapse:collapse;
}
.table11_7 th,.table11_7 td {
  border: 1px solid #2087fe;
  border-width:1px 0 1px 0;
  border:2px inset #ffffff;
}
.table11_7 tr {
  border: 1px solid #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/views/staff/Wage.vue